// INSIDO (17-icones-mono): unread total shared by the dynamic favicon
// (Favicon.tsx) and the desktop badge. Copied verbatim from
// `computeUnreadTotal` in module 12b's components/client/DesktopBridge.tsx;
// once 12b-desktop-web is merged, DesktopBridge should import it from here
// instead of keeping its own copy.
import type { Client } from "stoat.js";

import type { State } from "@revolt/state";

/**
 * Unread total: the sum of the numbers the client's own sidebar shows, using
 * the same sources and rules (no reimplementation):
 * - unread conversations, as in src/interface/Sidebar.tsx
 *   (`state.ordering.orderedConversations(client).filter(c => c.unread)`),
 *   each counting its mention count like ServerList's bubble, minimum 1;
 * - per-organisation mentions, as in ServerList (`server.mentions.length`);
 * - pending friend requests, as ServerList's Home badge
 *   (`relationship === "Incoming"`).
 * @param client Logged-in client
 * @param state Client state (ordering store)
 * @returns Unread count
 */
export function computeUnreadTotal(client: Client, state: State): number {
  const conversations = state.ordering
    .orderedConversations(client)
    .filter((channel) => channel.unread)
    .reduce(
      (total, channel) => total + Math.max(1, channel.mentions?.size ?? 0),
      0,
    );

  const serverMentions = state.ordering
    .orderedServers(client)
    .reduce((total, server) => total + server.mentions.length, 0);

  const friendRequests = client.users.filter(
    (user) => user.relationship === "Incoming",
  ).length;

  return conversations + serverMentions + friendRequests;
}
